import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

export const bestReviewsStyles: DomainsBaseStyles = {
  ...defaultStyles,
}
